import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {
  excludedUrl = ['/external/chatRequest', '/alerts/alertStatistics', '/entities/entityCategoryCount',
    '/entities/entityInfo', '/entities/activeEntities', '/entities/entityStatistics', '/entities/scoreBasedEntities',
    '/alerts/alerts/1', '/tracker/trackEntity', '/tracker/alertsCount', '/sites/siteInfo', '/entities/scoreDetails',
    '/entities/driverDetails', '/entities/certificateDetails', '/entities/entityAttributes', '/entities/entityIcons',
    '/tracker/locateEntity'];
  constructor(public jwtHelper: JwtHelperService) { }
  public getToken() {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('token');
    }
    else {
      return null;
    }
  }

  public getTenantId() {
    if (localStorage.getItem('tenantId')) {
      return localStorage.getItem('tenantId');
    }
    else {
      return null;
    }
  }

  public isAuthenticated(): boolean {
    const token: any = localStorage.getItem('token')?.toString();
    return !this.jwtHelper.isTokenExpired(token);
  }

  public isLoaderNeeded(url: string) {
    return this.excludedUrl.includes(url);
  }
}
